<template>
	<span
		v-bind:class="{
			day:date.timestamp !== 0,
			empty:date.timestamp === 0,
			today:toDay === date.timestamp,
			from:from === date.timestamp,
			to:to === date.timestamp,
			// range:from < date.timestamp && to > date.timestamp,
			disabled:disabled,
		}"
		v-on:click="selectedDay">
			<span>{{date.day > 0 ? date.day : ''}}</span>
		</span>
</template>

<script>
export default {
	props:['toDay', 'date', 'from', 'to', 'min', 'max', 'selectLimit'],
	data(){
		return {}
	},
	created(){},
	mounted(){},
	computed:{
		disabled(){
			return (this.min !== null && this.date.timestamp < this.min) 
				|| (this.max !== null && this.date.timestamp > this.max) 
				// || this.selectLimit;
		}
	},
	methods:{
		selectedDay(){
			!this.disabled && this.$emit('selectedDay', this.date.day);
		}
	}
}
</script>

<style lang="scss" scoped>
.empty {
	width: 0;
	height: 0;
	border: none;
	background: none;
	text-indent: -9999px;
}

.day {
	position: relative;
	display: table-cell;
	width: calc(100% / 7);
	height: 47px;
	text-align: center;
	vertical-align: middle;

	>span {
		display: inline-block;
		width: 40px;
		height: 40px;
		line-height: 40px;
		text-align: center;
		font-size: 15px;
		font-weight: 500;
		color: #141414;
		cursor: pointer;
	}
	
	&:hover {
		>span {
			border-radius: 100%;
			background: #f1f1f1;
		}
	}
	
	&.today,
	&.from,
	&.to {
		>span {
			border-radius: 100%;
			background: #ffd000;
			font-weight: 600;
		}
	}

	// &.range {
	// 	background: #eee;
	// }
	
	&.disabled {
		> span {
			border: none;
			background: none;
			// text-decoration: line-through;
			font-weight: 400;
			color: #c4c4c4;
			cursor: default;

			&:hover {
				border: none;
			}
		}
	}
}
</style>
